export var lowerCase = function lowerCase(stringToLowerCase) {
  return typeof stringToLowerCase === 'string' ? stringToLowerCase.toLowerCase() : undefined;
};